export default "__VITE_ASSET__db1395b9__"